module.exports = __webpack_public_path__ + "img/happiest_workplace@2x.d0c04475.png";